module.exports = __webpack_public_path__ + "img/plane_track_mobile_3.5b0a5f61.svg";